import "../style.scss";

import Euro from "@mui/icons-material/Euro";
import { InputLabel } from "@mui/material";
import StyledTextField from "components/shared/StyledTextField/StyledTextField";
import { Controller, useForm, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

interface PriceFormComponentProps {
    label: string;
    placeholder?: string;
    control: any;
    controlName: string;
    error?: any;
    required?: boolean;
    customRequiredMessage?: string;
    disabled?: boolean;
}

const PriceFormComponent = (props: PriceFormComponentProps) => {
    const {
        label,
        placeholder,
        control,
        controlName,
        error,
        required,
        customRequiredMessage,
        disabled = false,
    } = props;
    const [t] = useTranslation();

    return (
        <div className="form-component">
            <Controller
                name={controlName}
                control={control}
                rules={{
                    required: required
                        ? customRequiredMessage
                            ? customRequiredMessage
                            : t("NewElement.Required")
                        : undefined,
                    validate: (content: string) => {
                        if (!isNaN(+content.replace(",", "."))) return true;
                        else return t("NewElement.Number");
                    },
                }}
                render={({ field }) => {
                    return (
                        <>
                            <label className="form-component-label" htmlFor={controlName}>
                                {required ? `${label}*` : label}
                            </label>
                            <StyledTextField
                                {...field}
                                error={!!error}
                                name={controlName}
                                fullWidth
                                placeholder={placeholder ?? ""}
                                InputProps={{
                                    endAdornment: <Euro sx={{ color: "#A8A8A8", height: "18px", width: "18px" }} />,
                                }}
                                helperText={error?.message ?? ""}
                                disabled={disabled}
                            />
                        </>
                    );
                }}
            />
        </div>
    );
};

export default PriceFormComponent;
